import React, { useState, useEffect } from 'react';
import '../../css/BdStyles.css';
import { API_BASE_URL } from '../scripts/control';
import { useAdminAuth } from '../../../context/AdminAuthContext';

const BdTags = () => {
  const [tags, setTags] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTag, setSelectedTag] = useState("");
  const [newTagName, setNewTagName] = useState('');
  const [newTagDescription, setNewTagDescription] = useState('');
  const [editingTag, setEditingTag] = useState("");
  const [editTagName, setEditTagName] = useState('');
  const [editTagDescription, setEditTagDescription] = useState('');

  const { isAdmin } = useAdminAuth();

  // Obtener etiquetas desde el backend get_tags.php
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/get_tags.php`);
        const data = await response.json();
        if (data.success && data.tags && Array.isArray(data.tags)) {
          const sortedTags = data.tags.sort((a, b) =>
            a.tagName.localeCompare(b.tagName, undefined, { sensitivity: 'base' })
          );
          setTags(sortedTags);
          setFilteredTags(sortedTags);
        }
      } catch (error) {
      }
    };

    fetchTags();
  }, []);

  // Filtrar etiquetas según el término de búsqueda (sin importar acentos)
  useEffect(() => {
    const normalizedSearchTerm = searchTerm
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    const results = tags.filter(tag => {
      const normalizedTagName = tag.tagName
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      return normalizedTagName.includes(normalizedSearchTerm);
    });
    setFilteredTags(results);
  }, [searchTerm, tags]);

  // Muestra el modal de detalles de la etiqueta
  const handleTagClick = (tag) => {
    setSelectedTag(tag);
    const modalEl = document.getElementById('exampleModal');
    const modal = new window.bootstrap.Modal(modalEl);
    modal.show();
  };

  // Agregar una nueva etiqueta (solo para admin)
  const handleAddTag = async (e) => {
    e.preventDefault();
    if (!newTagName.trim()) {
      alert("El nombre de la etiqueta es obligatorio.");
      return;
    }
    const tagData = {
      tagName: newTagName.trim(),
      tagDescription: newTagDescription.trim()
    };

    try {
      const response = await fetch(`${API_BASE_URL}/api/add_tag.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tagData)
      });
      const data = await response.json();
      if (data.success) {
        const addedTag = data.tag;
        const updatedTags = [...tags, addedTag].sort((a, b) =>
          a.tagName.localeCompare(b.tagName, undefined, { sensitivity: 'base' })
        );
        setTags(updatedTags);
        setFilteredTags(updatedTags);
        setNewTagName('');
        setNewTagDescription('');
      } else {
        alert("Error al agregar la etiqueta: " + data.message);
      }
    } catch (error) {
      alert("Ocurrió un error al agregar la etiqueta.");
    }
  };

  // Inicia la edición de una etiqueta (solo para admin)
  const handleEditTag = (tag) => {
    setEditingTag(tag);
    setEditTagName(tag.tagName);
    setEditTagDescription(tag.tagDescription);
    const modalEl = document.getElementById('editTagModal');
    const modal = new window.bootstrap.Modal(modalEl);
    modal.show();
  };

  // Guarda los cambios de edición de la etiqueta
  const handleSaveEditTag = async (e) => {
    e.preventDefault();
    if (!editTagName || !editTagName.trim()) {
      alert("El nombre de la etiqueta es obligatorio.");
      return;
    }
    const tagData = {
      idTag: editingTag.idTag,
      tagName: editTagName.trim(),
      tagDescription: editTagDescription.trim()
    };

    try {
      const response = await fetch(`${API_BASE_URL}/api/update_tag.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tagData)
      });
      const data = await response.json();
      if (data.success) {
        const updatedTags = tags.map(tag =>
          tag.idTag === editingTag.idTag ? data.tag : tag
        );
        updatedTags.sort((a, b) =>
          a.tagName.localeCompare(b.tagName, undefined, { sensitivity: 'base' })
        );
        setTags(updatedTags);
        setFilteredTags(updatedTags);
        // Cerrar el modal de edición
        const modalEl = document.getElementById('editTagModal');
        const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
        modalInstance.hide();
        setEditingTag(null);
      } else {
        alert("Error al actualizar la etiqueta: " + data.message);
      }
    } catch (error) {
      alert("Ocurrió un error al actualizar la etiqueta.");
    }
  };

  // Eliminar una etiqueta (solo para admin)
  const handleDeleteTag = async (tag) => {
    if (!window.confirm(`¿Estás seguro de eliminar la etiqueta "${tag.tagName}"?`)) return;
    try {
      const response = await fetch(`${API_BASE_URL}/api/delete_tag.php`, {
        method: 'POST', // Se puede usar POST para esta acción
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idTag: tag.idTag })
      });
      const data = await response.json();
      if (data.success) {
        const updatedTags = tags.filter(t => t.idTag !== tag.idTag);
        setTags(updatedTags);
        setFilteredTags(updatedTags);
      } else {
        alert("Error al eliminar la etiqueta: " + data.message);
      }
    } catch (error) {
      alert("Ocurrió un error al eliminar la etiqueta.");
    }
  };

  return (
    <div className="bd">
    <div className="container">
      <h2 className="title">Etiquetas</h2>

      {/* Buscador de etiquetas */}
      <div className="search-container mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar etiqueta..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Lista de etiquetas filtradas */}
      <div className="row">
        {filteredTags.map(tag => (
          <div className="col-md-4 mb-2" key={tag.idTag}>
            <div className="list-group-item d-flex align-items-center">
              <button
                type="button"
                onClick={() => handleTagClick(tag)}
                className="btn btn-outline-primary tag"
              >
                {tag.tagName}
              </button>
              {isAdmin && (
                <div>
                  <i
                    className="bi bi-pencil-square me-2"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleEditTag(tag)}
                  ></i>
                  <i
                    className="bi bi-trash"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDeleteTag(tag)}
                  ></i>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Formulario para agregar una etiqueta (solo admin) */}
      {isAdmin && (
        <div className="add-tag-form mt-4">
          <h3>Agregar nueva etiqueta</h3>
          <form onSubmit={handleAddTag}>
            <div className="form-group mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Nombre de la etiqueta"
                value={newTagName || ""}
                onChange={(e) => setNewTagName(e.target.value)}
              />
            </div>
            <div className="form-group mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Descripción de la etiqueta"
                value={newTagDescription}
                onChange={(e) => setNewTagDescription(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-success">
              Agregar etiqueta
            </button>
          </form>
        </div>
      )}

      {/* Modal para mostrar detalles de la etiqueta */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {selectedTag ? selectedTag.tagName : 'Etiqueta'}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {selectedTag ? selectedTag.tagDescription : 'No hay descripción disponible'}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal para editar etiqueta (solo admin) */}
      <div
        className="modal fade"
        id="editTagModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="editTagModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form onSubmit={handleSaveEditTag}>
              <div className="modal-header">
                <h5 className="modal-title" id="editTagModalLabel">Editar Etiqueta</h5>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nombre de la etiqueta"
                    value={editTagName}
                    onChange={(e) => setEditTagName(e.target.value)}
                  />
                </div>
                <div className="form-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Descripción de la etiqueta"
                    value={editTagDescription}
                    onChange={(e) => setEditTagDescription(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Guardar cambios
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default BdTags;
